import { useEffect, useState } from 'react'
import { Circle, Marker, Tooltip, useMapEvents } from 'react-leaflet'
import { divIcon, LatLng } from 'leaflet'

const invisibleIcon = divIcon({ className: '', iconSize: [0, 0], iconAnchor: [0, 0] })

function getNiceRadius(zoom: number): number {
  if (zoom <= 4) return 500000
  if (zoom <= 5) return 200000
  if (zoom <= 6) return 100000
  if (zoom <= 7) return 50000
  if (zoom <= 8) return 20000
  if (zoom <= 9) return 10000
  if (zoom <= 10) return 5000
  if (zoom <= 11) return 2000
  if (zoom <= 12) return 1000
  return 500
}

function formatRadius(meters: number): string {
  if (meters >= 1000) return `${meters / 1000} km radius`
  return `${meters} m radius`
}

const ScaleCircle: React.FC = () => {
  const [center, setCenter] = useState<LatLng | null>(null)
  const [zoom, setZoom] = useState<number>(4)

  const map = useMapEvents({
    moveend() {
      setCenter(map.getCenter())
    },
    zoomend() {
      setCenter(map.getCenter())
      setZoom(map.getZoom())
    },
  })

  useEffect(() => {
    setCenter(map.getCenter())
    setZoom(map.getZoom())
  }, [map])

  if (!center) return null

  const radius = getNiceRadius(zoom)
  // Top edge of the circle in geographic coords (1 degree lat ≈ 111,320 m)
  const topOfCircle: [number, number] = [center.lat + radius / 111320, center.lng]

  return (
    <>
      {/* White halo underneath for contrast against any background */}
      <Circle
        center={center}
        radius={radius}
        pathOptions={{
          color: '#000000',
          weight: 5,
          dashArray: '6 6',
          fillOpacity: 0,
          opacity: 0.8,
        }}
      />
      {/* White ring on top */}
      <Circle
        center={center}
        radius={radius}
        pathOptions={{
          color: '#ffffff',
          weight: 2,
          dashArray: '6 6',
          fillOpacity: 0,
          opacity: 1,
        }}
      />
      {/* Invisible marker at the top edge so the label sits above the circle */}
      <Marker position={topOfCircle} icon={invisibleIcon}>
        <Tooltip permanent direction="top" offset={[0, -4]} className="scale-circle-tooltip">
          {formatRadius(radius)}
        </Tooltip>
      </Marker>
    </>
  )
}

export default ScaleCircle
